import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
    margin: 0;
    justify-content: space-between;
  }
`;
export const CardSection = styled.div`
  margin-top: -1em;
  width: 100%;
  margin-left: 11em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-left: 0em;
    margin-top: 1.5em;
    width: 100%;
  }
`;
export const CardHeading = styled.div`
  color: #d7d7d7;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: right;
  width: 100%;
  display: flex;
  justify-content: space-between;

  div {
    width: fit-content;
    text-align: right;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    margin: 1em auto;
    margin-bottom: 0.6em;
  }
`;
export const CardContainer = styled.div`
  width: 100%;
  align-items: center;
  margin-top: 0.69em;
  max-height: 25em;
  overflow: auto;
  & {
    scrollbar-width: normal;
  }
  &::-webkit-scrollbar {
    width: 0.4em;
  }
  &::-webkit-scrollbar-thumb {
    background: #cecece;
    border-radius: 1em;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
    &::-webkit-scrollbar {
      width: 0em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Card = styled.div`
  width: 100%;
  padding: 0.62em 1.06em;
  margin: 0.6em auto;
  display: flex;
  cursor: pointer;
  border-radius: 0.5rem;
  border: 1px solid #f4f4f4;
  align-items: center;
  font-size: 0.875rem;
  justify-content: space-between;

  h3 {
    color: #000;
    font-weight: 700;
  }
  p {
    font-weight: 500;
  }
`;
export const Empty = styled.div`
  width: 100%;
  margin-top: 1em;
  padding-right: 50%;

  p {
    margin-top: 3.1em;
    text-align: center;
    color: #ccc;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    padding-right: 0%;
    padding-left: 5em;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 5.9em;
    padding-left: 0em;
  }
`;
export const ImageContainer = styled.div`
  width: 5.625rem;
  height: 5.625rem;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
